/************************************************************/
/* JavaScript for cooksondoor.com Energy Savings Calculator */
/************************************************************/

// Energy Savings Calculator - Temp-Master vs. Standard Service Door

function calculateSavingsTMvSD(drwd, drht) {
	/***************** 8' widths ************/
	if(drwd == "8" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$434");
		$(".resultsTable #z2 .amt").html("$346");
		$(".resultsTable #z3 .amt").html("$264");
		$(".resultsTable #z4 .amt").html("$218");
	} else if(drwd == "8" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$541");
		$(".resultsTable #z2 .amt").html("$431");
		$(".resultsTable #z3 .amt").html("$330");
		$(".resultsTable #z4 .amt").html("$271");
	} else if(drwd == "8" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$648");
		$(".resultsTable #z2 .amt").html("$517");
		$(".resultsTable #z3 .amt").html("$395");
		$(".resultsTable #z4 .amt").html("$325");
	} else if(drwd == "8" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$1072");
		$(".resultsTable #z2 .amt").html("$855");
		$(".resultsTable #z3 .amt").html("$654");
		$(".resultsTable #z4 .amt").html("$538");
	} else if(drwd == "8" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$1593");
		$(".resultsTable #z2 .amt").html("$1270");
		$(".resultsTable #z3 .amt").html("$971");
		$(".resultsTable #z4 .amt").html("$799");
	} 
	/***************** 10' widths ************/
	else if(drwd == "10" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$542");
		$(".resultsTable #z2 .amt").html("$432");
		$(".resultsTable #z3 .amt").html("$331");
		$(".resultsTable #z4 .amt").html("$272");
	} else if(drwd == "10" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$677");
		$(".resultsTable #z2 .amt").html("$539");
		$(".resultsTable #z3 .amt").html("$412");
		$(".resultsTable #z4 .amt").html("$339");
	} else if(drwd == "10" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$810");
		$(".resultsTable #z2 .amt").html("$646");
		$(".resultsTable #z3 .amt").html("$494");
		$(".resultsTable #z4 .amt").html("$406");
	} else if(drwd == "10" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$1340");
		$(".resultsTable #z2 .amt").html("$1068");
		$(".resultsTable #z3 .amt").html("$817");
		$(".resultsTable #z4 .amt").html("$672");
	} else if(drwd == "10" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$1992");
		$(".resultsTable #z2 .amt").html("$1587");
		$(".resultsTable #z3 .amt").html("$1214");
		$(".resultsTable #z4 .amt").html("$999");
	} 
	/***************** 12' widths ************/
	else if(drwd == "12" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$651");
		$(".resultsTable #z2 .amt").html("$519");
		$(".resultsTable #z3 .amt").html("$397");
		$(".resultsTable #z4 .amt").html("$326");
	} else if(drwd == "12" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$812");
		$(".resultsTable #z2 .amt").html("$647");
		$(".resultsTable #z3 .amt").html("$495");
		$(".resultsTable #z4 .amt").html("$407");
	} else if(drwd == "12" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$972");
		$(".resultsTable #z2 .amt").html("$775");
		$(".resultsTable #z3 .amt").html("$593");
		$(".resultsTable #z4 .amt").html("$488");
	} else if(drwd == "12" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$1608");
		$(".resultsTable #z2 .amt").html("$1282");
		$(".resultsTable #z3 .amt").html("$981");
		$(".resultsTable #z4 .amt").html("$807");
	} else if(drwd == "12" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$2390");
		$(".resultsTable #z2 .amt").html("$1905");
		$(".resultsTable #z3 .amt").html("$1457");
		$(".resultsTable #z4 .amt").html("$1199");
	} 
	/***************** 20' widths ************/
	else if(drwd == "20" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$1084");
		$(".resultsTable #z2 .amt").html("$864");
		$(".resultsTable #z3 .amt").html("$661");
		$(".resultsTable #z4 .amt").html("$544");
	} else if(drwd == "20" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$1353");
		$(".resultsTable #z2 .amt").html("$1078");
		$(".resultsTable #z3 .amt").html("$825");
		$(".resultsTable #z4 .amt").html("$679");
	} else if(drwd == "20" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$1621");
		$(".resultsTable #z2 .amt").html("$1292");
		$(".resultsTable #z3 .amt").html("$988");
		$(".resultsTable #z4 .amt").html("$813");
	} else if(drwd == "20" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$2681");
		$(".resultsTable #z2 .amt").html("$2137");
		$(".resultsTable #z3 .amt").html("$1634");
		$(".resultsTable #z4 .amt").html("$1345");
	} else if(drwd == "20" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$3983");
		$(".resultsTable #z2 .amt").html("$3174");
		$(".resultsTable #z3 .amt").html("$2428");
		$(".resultsTable #z4 .amt").html("$1998");
	} 
	/***************** 30' widths ************/
	else if(drwd == "30" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$1627");
		$(".resultsTable #z2 .amt").html("$1296");
		$(".resultsTable #z3 .amt").html("$992");
		$(".resultsTable #z4 .amt").html("$816");
	} else if(drwd == "30" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$2030");
		$(".resultsTable #z2 .amt").html("$1618");
		$(".resultsTable #z3 .amt").html("$1237");
		$(".resultsTable #z4 .amt").html("$1018");
	} else if(drwd == "30" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$2431");
		$(".resultsTable #z2 .amt").html("$1937");
		$(".resultsTable #z3 .amt").html("$1482");
		$(".resultsTable #z4 .amt").html("$1219");
	} else if(drwd == "30" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$4021");
		$(".resultsTable #z2 .amt").html("$3205");
		$(".resultsTable #z3 .amt").html("$2452");
		$(".resultsTable #z4 .amt").html("$2017");
	} else if(drwd == "30" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$5975");
		$(".resultsTable #z2 .amt").html("$4762");
		$(".resultsTable #z3 .amt").html("$3643");
		$(".resultsTable #z4 .amt").html("$2997");
	} else {
		$("#savresults").html("Must be an error, because my calculator spat nothing back at me..... Try again next time!");
	}	
}
// Energy Savings Calculator - Temp-Master vs. Standard Service Door

// Energy Savings Calculator - Temp-Master vs. Standard Insulated Door

function calculateSavingsTMvID(drwd, drht) {
	/***************** 8' widths ************/
	if(drwd == "8" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$184");
		$(".resultsTable #z2 .amt").html("$147");
		$(".resultsTable #z3 .amt").html("$112");
		$(".resultsTable #z4 .amt").html("$92");
	} else if(drwd == "8" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$229");
		$(".resultsTable #z2 .amt").html("$183");
		$(".resultsTable #z3 .amt").html("$140");
		$(".resultsTable #z4 .amt").html("$115");
	} else if(drwd == "8" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$275");
		$(".resultsTable #z2 .amt").html("$219");
		$(".resultsTable #z3 .amt").html("$167");
		$(".resultsTable #z4 .amt").html("$138");
	} else if(drwd == "8" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$455");
		$(".resultsTable #z2 .amt").html("$363");
		$(".resultsTable #z3 .amt").html("$277");
		$(".resultsTable #z4 .amt").html("$228");
	} else if(drwd == "8" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$676");
		$(".resultsTable #z2 .amt").html("$539");
		$(".resultsTable #z3 .amt").html("$412");
		$(".resultsTable #z4 .amt").html("$339");
	} 
	/***************** 10' widths ************/
	else if(drwd == "10" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$230");
		$(".resultsTable #z2 .amt").html("$183");
		$(".resultsTable #z3 .amt").html("$140");
		$(".resultsTable #z4 .amt").html("$115");
	} else if(drwd == "10" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$287");
		$(".resultsTable #z2 .amt").html("$229");
		$(".resultsTable #z3 .amt").html("$175");
		$(".resultsTable #z4 .amt").html("$144");
	} else if(drwd == "10" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$344");
		$(".resultsTable #z2 .amt").html("$274");
		$(".resultsTable #z3 .amt").html("$201");
		$(".resultsTable #z4 .amt").html("$173");
	} else if(drwd == "10" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$569");
		$(".resultsTable #z2 .amt").html("$453");
		$(".resultsTable #z3 .amt").html("$347");
		$(".resultsTable #z4 .amt").html("$286");
	} else if(drwd == "10" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$845");
		$(".resultsTable #z2 .amt").html("$674");
		$(".resultsTable #z3 .amt").html("$515");
		$(".resultsTable #z4 .amt").html("$424");
	} 
	/***************** 12' widths ************/
	else if(drwd == "12" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$276");
		$(".resultsTable #z2 .amt").html("$220");
		$(".resultsTable #z3 .amt").html("$168");
		$(".resultsTable #z4 .amt").html("$139");
	} else if(drwd == "12" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$345");
		$(".resultsTable #z2 .amt").html("$275");
		$(".resultsTable #z3 .amt").html("$210");
		$(".resultsTable #z4 .amt").html("$173");
	} else if(drwd == "12" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$412");
		$(".resultsTable #z2 .amt").html("$329");
		$(".resultsTable #z3 .amt").html("$251");
		$(".resultsTable #z4 .amt").html("$207");
	} else if(drwd == "12" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$683");
		$(".resultsTable #z2 .amt").html("$544");
		$(".resultsTable #z3 .amt").html("$416");
		$(".resultsTable #z4 .amt").html("$342");
	} else if(drwd == "12" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$1014");
		$(".resultsTable #z2 .amt").html("$808");
		$(".resultsTable #z3 .amt").html("$618");
		$(".resultsTable #z4 .amt").html("$509");
	} 
	/***************** 20' widths ************/
	else if(drwd == "20" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$460");
		$(".resultsTable #z2 .amt").html("$367");
		$(".resultsTable #z3 .amt").html("$280");
		$(".resultsTable #z4 .amt").html("$231");
	} else if(drwd == "20" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$574");
		$(".resultsTable #z2 .amt").html("$458");
		$(".resultsTable #z3 .amt").html("$350");
		$(".resultsTable #z4 .amt").html("$288");
	} else if(drwd == "20" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$688");
		$(".resultsTable #z2 .amt").html("$548");
		$(".resultsTable #z3 .amt").html("$419");
		$(".resultsTable #z4 .amt").html("$345");
	} else if(drwd == "20" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$1137");
		$(".resultsTable #z2 .amt").html("$907");
		$(".resultsTable #z3 .amt").html("$694");
		$(".resultsTable #z4 .amt").html("$571");
	} else if(drwd == "20" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$1691");
		$(".resultsTable #z2 .amt").html("$1347");
		$(".resultsTable #z3 .amt").html("$1030");
		$(".resultsTable #z4 .amt").html("$848");
	} 
	/***************** 30' widths ************/
	else if(drwd == "30" && drht == "8") {
		$(".resultsTable #z1 .amt").html("$690");
		$(".resultsTable #z2 .amt").html("$550");
		$(".resultsTable #z3 .amt").html("$421");
		$(".resultsTable #z4 .amt").html("$346");
	} else if(drwd == "30" && drht == "10") {
		$(".resultsTable #z1 .amt").html("$861");
		$(".resultsTable #z2 .amt").html("$687");
		$(".resultsTable #z3 .amt").html("$525");
		$(".resultsTable #z4 .amt").html("$432");
	} else if(drwd == "30" && drht == "12") {
		$(".resultsTable #z1 .amt").html("$1032");
		$(".resultsTable #z2 .amt").html("$822");
		$(".resultsTable #z3 .amt").html("$629");
		$(".resultsTable #z4 .amt").html("$518");
	} else if(drwd == "30" && drht == "20") {
		$(".resultsTable #z1 .amt").html("$1707");
		$(".resultsTable #z2 .amt").html("$1360");
		$(".resultsTable #z3 .amt").html("$1041");
		$(".resultsTable #z4 .amt").html("$856");
	} else if(drwd == "30" && drht == "30") {
		$(".resultsTable #z1 .amt").html("$2535");
		$(".resultsTable #z2 .amt").html("$2021");
		$(".resultsTable #z3 .amt").html("$1546");
		$(".resultsTable #z4 .amt").html("$1271");
	} else {
		$("#savresults").html("Must be an error, because my calculator spat nothing back at me..... Try again next time!");
	}	
}

// Energy Savings Calculator - Temp-Master vs. Standard Insulated Door



$(document).ready(function() {
	
	// Energy Savings Calculator
	$(".calcbtnsdjs").click(function(){
		if($("#doorWDsd").val() == "err" && $("#doorHTsd").val() == "err") {
			alert("Please select opening width and height.");
		} else if($("#doorWDsd").val() == "err") {
			alert("Please select opening width.");
		} else if($("#doorHTsd").val() == "err") {
			alert("Please select opening height.");
		} else {
			$(".calcbtnsdjs").colorbox({inline:true, onClosed:function(){
				$("#popupWDsd").val("err");
				$("#popupHTsd").val("err");
			}});
			var width = $("#doorWDsd").val();;
			var height = $("#doorHTsd").val();
			$("#savresults p .openwd").html(width);
			$("#savresults p .openht").html(height);
			$(".footnotesd").show();
			$(".footnoteid").hide();
			calculateSavingsTMvSD(width, height);
		}
	});
	
	$(".popbtncontsd img").click(function(){
		if($("#popupWDsd").val() == "err" && $("#popupHTsd").val() == "err") {
			alert("Please select opening width and height.");
		} else if($("#popupWDsd").val() == "err") {
			alert("Please select opening width.");
		} else if($("#popupHTsd").val() == "err") {
			alert("Please select opening height.");
		} else {
			var pwidth = $("#popupWDsd").val();
			var pheight = $("#popupHTsd").val();
			$("#savresults p .openwd").html(pwidth);
			$("#savresults p .openht").html(pheight);
			$(".footnotesd").show();
			$(".footnoteid").hide();
			calculateSavingsTMvSD(pwidth, pheight);
		}
	});
	
	
	$(".calcbtnidjs").click(function(){
		if($("#doorWDid").val() == "err" && $("#doorHTid").val() == "err") {
			alert("Please select opening width and height.");
		} else if($("#doorWDid").val() == "err") {
			alert("Please select opening width.");
		} else if($("#doorHTid").val() == "err") {
			alert("Please select opening height.");
		} else {
			$(".calcbtnidjs").colorbox({inline:true, onClosed:function(){
				$("#popupWDid").val("err");
				$("#popupHTid").val("err");
			}});
			var width = $("#doorWDid").val();;
			var height = $("#doorHTid").val();
			$("#savresults p .openwd").html(width);
			$("#savresults p .openht").html(height);
			$(".footnoteid").show();
			$(".footnotesd").hide();
			calculateSavingsTMvID(width, height);
		}
	});
	
	$(".popbtncontid img").click(function(){
		if($("#popupWDid").val() == "err" && $("#popupHTid").val() == "err") {
			alert("Please select opening width and height.");
		} else if($("#popupWDid").val() == "err") {
			alert("Please select opening width.");
		} else if($("#popupHTid").val() == "err") {
			alert("Please select opening height.");
		} else {
			var pwidth = $("#popupWDid").val();
			var pheight = $("#popupHTid").val();
			$("#savresults p .openwd").html(pwidth);
			$("#savresults p .openht").html(pheight);
			$(".footnoteid").show();
			$(".footnotesd").hide();
			calculateSavingsTMvID(pwidth, pheight);
		}
	});
	// Energy Savings Calculator

});

